/**
 * Created by AlexanderC on 6/15/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ObjectToJoi = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Joi = require('./Helpers/Joi');

var _joi = require('joi');

var _joi2 = _interopRequireDefault(_joi);

var _InvalidSchemaException = require('./Exception/InvalidSchemaException');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Exporting simple object to joi
 */
let ObjectToJoi = exports.ObjectToJoi = function () {
  /**
   * @param {Object} baseObject
   */
  function ObjectToJoi(baseObject) {
    _classCallCheck(this, ObjectToJoi);

    this._baseObject = baseObject;
  }

  /**
   * @returns {Object}
   */


  _createClass(ObjectToJoi, [{
    key: 'transform',


    /**
     * @returns {Object}
     */
    value: function transform() {
      try {
        return ObjectToJoi._transform(this._baseObject);
      } catch (e) {
        throw new _InvalidSchemaException.InvalidSchemaException(this._baseObject, e);
      }
    }

    /**
     * @param {Object} obj
     * @returns {Object}
     * @private
     */

  }, {
    key: 'baseObject',
    get: function get() {
      return this._baseObject;
    }
  }], [{
    key: '_transform',
    value: function _transform(obj) {
      let transObj = {};

      for (let property in obj) {
        if (!obj.hasOwnProperty(property)) {
          continue;
        }

        let value = obj[property];

        if (typeof value === 'object') {
          transObj[property] = ObjectToJoi._transform(value);
        } else {
          let validationSchema = _Joi.Joi[value];

          if (typeof validationSchema === 'undefined') {
            throw new _InvalidSchemaException.InvalidSchemaException(obj, `Unknown field type ${value}`);
          }

          transObj[property] = validationSchema;
        }
      }

      return _joi2.default.object().keys(transObj);
    }
  }]);

  return ObjectToJoi;
}();


//////////////////
// WEBPACK FOOTER
// ../~/deep-validation/lib.compiled/ObjectToJoi.js
// module id = 464
// module chunks = 0